import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/Herosection.css';

import slide1 from '../assets/banner1.jpg';
import slide2 from '../assets/fl2.png';
import slide3 from '../assets/cs1.jpg';
import slide4 from '../assets/banner4.jpg';

import SplitText from '../components/SplitText';

const images = [slide1, slide2, slide3, slide4];
const words = ['QUALITY WEBSITE DESIGN', 'GST REGISTRATION', 'MANPOWER OUTSOURCING'];

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Background image rotation
  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(imageInterval);
  }, []);

  // Word rotation
  useEffect(() => {
    const wordInterval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
    }, 2000);
    return () => clearInterval(wordInterval);
  }, []);

  // Animation variants for each letter
  const letterVariants = {
    initial: { opacity: 0, y: 20 },
    animate: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.05,
        duration: 0.4,
      },
    }),
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };

  const currentWord = words[currentWordIndex];

  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${images[currentIndex]})` }}
    >
      <div
        ref={ref}
        className={`hero-content dark-silver-wrapper ${inView ? 'fade-up' : ''}`}
      >
       <SplitText
  text="MATRIX CONSULTANCY SERVICES"
  className="dark-silver-text shiny-wrapper"
  delay={50}
  animationFrom={{ opacity: 0, transform: 'translate3d(0, 40px, 0)' }}
  animationTo={{ opacity: 1, transform: 'translate3d(0, 0, 0)' }}
  textAlign="center"
/>



        <div className="text-animation">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentWordIndex}
              className="dynamic-text"
              initial="initial"
              animate="animate"
              exit="exit"
              style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}
            >
              {currentWord.split('').map((letter, i) => (
                <motion.span
                  key={`${letter}-${i}`}
                  variants={letterVariants}
                  custom={i}
                  style={{ display: 'inline-block' }}
                >
                  {letter === ' ' ? '\u00A0' : letter}
                </motion.span>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
